export const routes = (parentName) => {
  return [
    {
      path: "hospital",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Hospital`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "special",
          name: `${parentName}-Hospital-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "cost",
          name: `${parentName}-Hospital-Cost`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Hospital-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

         {
          path: "per",
          name: `${parentName}-Hospital-List-Per`,
          component: () => import("./ListPer.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Hospital-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Hospital-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Hospital-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
